import { QueryClient } from 'react-query'

let instance = null

export const init = () => {
  instance = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false
      }
    }
  })

  return instance
}

export const get = () => instance
